import React, { useState } from "react";
import ShowOnTop, { Form_Container } from "./showOnTop";
import { Input } from "./InputTemplate";
import { ref, update } from "firebase/database";
import { database } from "../config/config";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAppContext } from "../context/appContext";
import { API_URL } from "../apis/apiurl";

const EditUserListComponents = ({
  setEditList,
  editComponents,
  setUsers,
  users,
  containCompany,
  FetchAllUser,
}) => {
  const [inputValue, setInputValue] = useState(editComponents || {});
  const [loading, setLoading] = useState(false);

  const { isPopupOpen, setIsPopupOpen, popupMessage, setPopupMessage } =
    useAppContext();

  const InputHandler = (e) => {
    const { name, value } = e.target;
    setInputValue((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  const EditUserList = () => {
    setLoading(true);

    const updatedReportTemplate = Object.fromEntries(
      Object.entries({
        firstName: inputValue?.firstName,
        lastName: inputValue?.lastName,
        phone: inputValue?.phone,
        city: inputValue?.city,
        state: inputValue?.state,
        streetAddress: inputValue?.streetAddress,
        // type: inputValue?.type,
        zipCode: inputValue?.zipCode,
        ...(containCompany ? { company: inputValue?.company } : {}),
      }).filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined
      )
    );

    console.log(updatedReportTemplate);

    const args = {
      userId: editComponents?.id,
      ...updatedReportTemplate,
    };

    // console.log("args123", args);
    let data = JSON.stringify({
      query:
        "mutation UpdateUser($args: UpdateUserInput!) { updateUser(args: $args) {success data } }",
      variables: {
        args: {
          userId: editComponents?.id,
          ...updatedReportTemplate,
        },
      },
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_URL}/graphql`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        const data = response?.data?.data?.updateUser;

        if (data.success) {
          setPopupMessage("User updated successfully");
          FetchAllUser();
          setEditList(false);
          setLoading(false);
        } else {
          setLoading(false);
          setPopupMessage("User not updated");
          FetchAllUser();
          setEditList(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        setEditList(false);
      });

    // update(usersRef, updatedReportTemplate)
    //   .then(() => {
    //     const newUser = users.filter((item) => item?.id !== editComponents?.id);
    //     const CombineUser = [
    //       ...newUser,
    //       { id: editComponents?.id, ...updatedReportTemplate },
    //     ];

    //     console.log("Combined User List", CombineUser);
    //     // Assuming setUsers is a state setter for the user list
    //     setUsers(CombineUser);
    //     setEditList(false);
    //     console.log("Update Success");
    //   })
    //   .catch((error) => {
    //     console.error("Update error", error);
    //     // Handle error
    //   });
  };

  console.log("inputValue", inputValue?.phone);

  return (
    <ShowOnTop setEditList={setEditList}>
      <Form_Container>
        <div className="flex items-center justify-between mb-7 ">
          <h1 className="capitalize text-2xl font-semibold">
            Edit User Information
          </h1>
          <div className="bg-blue-100 px-4 py-1 border border-blue-300 text-blue-700 text-sm rounded-md">
            {editComponents?.role}
          </div>
        </div>
        <div className="px-5 flex flex-col gap-3">
          <div className="flex gap-3">
            <Input
              name="firstName"
              placeholder="first name"
              className="border"
              onChange={InputHandler}
              value={inputValue?.firstName}
            />
            <Input
              name="lastName"
              placeholder="last name"
              className="border"
              onChange={InputHandler}
              value={inputValue?.lastName}
            />
          </div>

          {/* <Input
            name='email'
            placeholder='email'
            className='border w-full text-zinc-600'
            // onChange={InputHandler}
            value={inputValue?.email}
disabled
          /> */}
          <div className="flex gap-3">
            <Input
              name="phone"
              placeholder="phone"
              className="border"
              onChange={InputHandler}
              value={inputValue?.phone}
            />
            <Input
              name="state"
              placeholder="state"
              className="border"
              onChange={InputHandler}
              value={inputValue?.state}
            />
          </div>
          <div className="flex gap-3">
            <Input
              name="streetAddress"
              placeholder="street address"
              className="border"
              onChange={InputHandler}
              value={inputValue?.streetAddress}
            />
            <Input
              name="city"
              placeholder="city"
              className="border"
              onChange={InputHandler}
              value={inputValue?.city}
            />
          </div>
          {containCompany && (
            <Input
              name="company"
              placeholder="company"
              className="border"
              onChange={InputHandler}
              value={inputValue?.company}
            />
          )}
          <Input
            name="zipCode"
            placeholder="zip code"
            className="border"
            type="number"
            onChange={InputHandler}
            value={inputValue?.zipCode}
          />
          <div className="mt-7 flex justify-between">
            <button onClick={() => setEditList(false)}>Close</button>
            <button
              className="bg-blue-600 text-white p-2 px-6 rounded-md"
              onClick={EditUserList}
            >
              {loading ? (
                <Loader2 className="animate-spin" size={20} />
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>
      </Form_Container>
    </ShowOnTop>
  );
};

export default EditUserListComponents;
